/**
 * 产康单项目预约弹窗
 * 按标准：WrappedModal + SingleProjectAppointmentForm，提交成功后 onSuccess
 */
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { message } from 'antd'
import dayjs from 'dayjs'
import WrappedModal from '@/components/WrappedModal'
import { singleProjectAppointmentThunk } from '@/redux/order/dispatchPageSlice'
import SingleProjectAppointmentForm from './SingleProjectAppointmentForm'

class SingleProjectAppointmentModal extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    orderId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    packageItemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    projectName: PropTypes.string,
    /** 服务时长（分钟），套餐项目行 record.serviceTime，用于计算 endTime 与表单时段禁选 */
    serviceTime: PropTypes.number,
    baseProps: PropTypes.object,
    onSuccess: PropTypes.func
  }

  handleOk = async (formRef) => {
    try {
      const { packageItemId, projectId, onSuccess, dispatch, serviceTime } = this.props
      const form = formRef?.current
      if (!form) throw new Error('表单未就绪')

      const serviceMinutes = Number(serviceTime)
      if (!Number.isFinite(serviceMinutes) || serviceMinutes <= 0) {
        throw new Error('服务时长无效，请从列表重新打开预约')
      }

      const fields = await form.validateFields()
      const dateValue = fields.appointmentDate
      const dateStr = typeof dateValue?.format === 'function'
        ? dateValue.format('YYYY-MM-DD')
        : String(dateValue || '')
      const appointmentDate = dateStr ? +dayjs(dateStr).startOf('day') : null
      const startTimeStr = (fields.appointmentStartTime || '').trim()
      const startTime = startTimeStr ? +dayjs(`${dateStr} ${startTimeStr}`) : null
      const endTime = startTime != null
        ? +dayjs(startTime).add(serviceMinutes, 'minute')
        : null

      await dispatch(singleProjectAppointmentThunk({
        memberProjectId: packageItemId,
        projectId,
        appointmentDate,
        startTime,
        endTime,
        technicianId: fields.technicianId,
      })).unwrap()
      message.success('预约成功')
      if (typeof onSuccess === 'function') onSuccess()
    } catch (err) {
      message.error(err?.message || err || '预约失败')
      throw err
    }
  }

  render() {
    const { children, baseProps, title, width, serviceTime } = this.props
    const projectName = this.props.projectName
    const modalTitle = projectName ? `预约：${projectName}` : '单项目预约'
    return (
      <WrappedModal
        className="single-project-appointment-modal"
        children={children}
        destroyOnClose
        baseComponent={(
          <SingleProjectAppointmentForm
            key={`appt-${String(this.props.orderId ?? '')}-${String(this.props.packageItemId ?? '')}`}
          />
        )}
        baseProps={{ ...baseProps, serviceTime, orderId: this.props.orderId }}
        title={title || modalTitle}
        width={width || 760}
        okText="确认预约"
        onOk={this.handleOk}
      />
    )
  }
}

export default connect()(SingleProjectAppointmentModal)
